// extracted by css-extract-rspack-plugin
export default {"cls1":"TriagePage-cls1_n-0","cls2":"TriagePage-cls2_vvs TriagePage-cls1_n-0"};